import { render, staticRenderFns } from "./Samplingbox.vue?vue&type=template&id=1b65daa4&"
import script from "./Samplingbox.vue?vue&type=script&lang=js&"
export * from "./Samplingbox.vue?vue&type=script&lang=js&"
import style0 from "./Samplingbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports